var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgLogoPart1Button(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.784 39.4216L114.595 57.0543C18.3356 77.2074 -65.7782 124.167 -66.6136 124.638L-94.4962 107.526C-94.2008 106.874 -64.7369 39.4599 -67.6168 -51.8377L-34.7793 -64.1678C-29.842 -48.5716 -29.7856 -27.049 -29.8902 -24.2111C-31.4929 18.4347 -39.053 54.2488 -46.0724 79.1118C-19.2979 66.7668 18.6417 51.0738 61.7513 38.5595C58.1023 36.8537 54.8664 35.2999 52.1193 33.9208C41.802 36.8698 25.9298 41.5718 -1.2136 52.3456L-27.3152 36.5712C-27.1668 35.9293 -17.2463 -6.53517 -22.9413 -55.0026C-9.34179 -44.1099 4.19589 -34.3864 17.1969 -25.7889C17.6832 -12.154 17.2842 1.34562 15.2703 12.9801C34.2697 6.36582 49.669 2.01233 59.7897 -0.168379C90.9504 16.805 113.883 25.5749 118.661 27.3441C119.065 27.6206 119.36 27.8231 119.545 27.9517L117.778 39.4241L117.784 39.4216Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogoPart1Button);
export default __webpack_public_path__ + "static/media/bgLogoPart1_button.8b9836a560dd2fb26405e34e09c2bac1.svg";
export { ForwardRef as ReactComponent };